import { render, staticRenderFns } from "./IconGridView.vue?vue&type=template&id=160b6bcc"
import script from "./IconGridView.vue?vue&type=script&lang=js"
export * from "./IconGridView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports